export const SortTypeMap = {
    ASCEND: 1,
    DESCEND: 2,
};
